export default __webpack_public_path__ + "static/media/StockBack.5a16f629.svg";